var _defs, _circle, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 113.89 113.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-4{fill:none;}.cls-2{fill:#0c1f81;}.cls-3{fill:#ff8f0b;}.cls-4{stroke:#eaeced;stroke-width:4px;}.cls-5{clip-path:url(#clip-path);}.cls-6{fill:#fff;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 33.3,
    y: 30.35,
    width: 47.29,
    height: 53.18
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_6-3",
    "data-name": "Ellipse 6-3",
    className: "cls-2",
    cx: 56.94,
    cy: 56.94,
    r: 56.94
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_5",
    "data-name": "Ellipse 5"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 56.53,
    cy: 57.63,
    r: 53.66
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 56.53,
    cy: 57.63,
    r: 51.66
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_307",
    "data-name": "Group 307"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_306",
    "data-name": "Group 306"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_305",
    "data-name": "Group 305"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_304",
    "data-name": "Group 304"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_303",
    "data-name": "Group 303"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_137",
    "data-name": "Path 137"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M59.88,83.44A26.49,26.49,0,1,1,80.53,40.3a1.4,1.4,0,0,1-2.19,1.76,24.75,24.75,0,0,0-2.64-2.78,23.7,23.7,0,1,0,1.85,33.47,1.41,1.41,0,0,1,2.1,1.87A26.44,26.44,0,0,1,59.88,83.44Z"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Path_138",
    "data-name": "Path 138"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M60.92,75.46l-1.2,0a23.16,23.16,0,0,1-14.76-6,1.2,1.2,0,1,1,1.62-1.78A20.78,20.78,0,0,0,59.85,73c4.57.24,8.12-1,12.63-4.36a1.2,1.2,0,0,1,1.44,1.93C69.37,74,65.52,75.46,60.92,75.46Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_139",
    "data-name": "Path 139"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M71.49,55.88a12,12,0,1,1-12-12h0a12,12,0,0,1,12,12"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon5);
export default __webpack_public_path__ + "static/media/Icon5.b6d9c30a2eafdfeb19d119d497dc77c4.svg";
export { ForwardRef as ReactComponent };